/**
 * Inline loading state — used as the `Suspense` fallback when a tab is
 * being lazy-loaded, and by tabs that need to gate their own content
 * while initial data is fetched.
 *
 * @param {{ label?: string, fullscreen?: boolean }} props
 */
export default function BusyOverlay({ label = 'Loading…', fullscreen = false }) {
  return (
    <div className={`busy-overlay${fullscreen ? ' busy-overlay--fullscreen' : ''}`}>
      <i className="fas fa-circle-notch fa-spin" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
